// extracted by mini-css-extract-plugin
module.exports = {"total":"DisplayModal_total__1KM6t","actions":"DisplayModal_actions__27_me","Head":"DisplayModal_Head__2Zefe"};